import * as actionTypes from "./actionTypes";
import axios from "../../util/axios-reportonce";
import serverSelect from "../../serverSelect";
import authHeader from "../../services/auth-header";

export const loadSpecificListingSuccess = (data) => {
    return {
        type: actionTypes.LOAD_SPECIFIC_LISTING_SUCCESS,
        data: data,
    };
};

export const loadSpecificListingFail = (errorMessage, errorCode) => {
    return {
        type: actionTypes.LOAD_SPECIFIC_LISTING_FAIL,
        errorMessage: errorMessage,
        errorCode: errorCode,
    };
};

export const loadSpecificListingStart = (id) => {
    return {
        type: actionTypes.LOAD_SPECIFIC_LISTING_START,
        id: id,
    };
};

export const loadSpecificListing = (id) => {
    return (dispatch, getState) => {
        dispatch(loadSpecificListingStart(id));
        const request_options = authHeader(getState().user);
        const server = serverSelect();
        axios
            .get(`${server}/api/listings/${id}`, request_options)
            .then(function (response) {
                dispatch(loadSpecificListingSuccess(response.data));
            })
            .catch(function (error) {
                // handle error
                // console.log(`/api/listings/${id} error = `, error);
                // console.log(`/api/listings/${id} error.response = `, error.response);
                let errorMessage = error.toString();
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.detail
                ) {
                    // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                    errorMessage = error.response.data.detail;
                }
                let errorCode = false;
                if (error.response && error.response.status) {
                    // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                    errorCode = error.response.status;
                }
                dispatch(loadSpecificListingFail(errorMessage, errorCode));
            })
            .then(function () {
                // always executed
            });
    };
};
